import _taggedTemplateLiteral from "/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import React, { forwardRef, useState, useEffect } from 'react';
import { ClickAwayListener } from '@mui/material';
import { FadeInAnimation } from '@next/animations';
import { styled } from '@mui/material/styles';
import MuiPopper from '@mui/material/Popper';
const Popper = styled(MuiPopper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    && {\n        display: flex;\n        justify-content: center;\n        z-index: 3;\n        border-radius: ", ";\n\n        // for landscape iPhone XR only\n        @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape) {\n            top: 3.125rem;\n        }\n    }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.uxfabric.shape.global.popover.default.borderRadius;
});
const Arrow = styled("div", {
  shouldForwardProp: p => p !== "showHeader"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    top: 0.375rem;\n    width: 1.375rem;\n    height: 1.125rem;\n    margin-top: -1.0625rem;\n    position: absolute;\n    font-size: 1.125rem;\n\n    &&:before {\n        border: 0.0625rem solid ", ";\n        border-bottom: none;\n        border-left: none;\n        width: 1.375rem;\n        height: 1.375rem;\n        margin: auto;\n        content: \"\";\n        display: block;\n        background: ", ";\n\n        transform: rotate(-45deg);\n        -webkit-transform: rotate(-45deg);\n    }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.uxfabric.components.dialog.dialogHeader.default.borderColor;
}, _ref3 => {
  let {
    theme,
    showHeader
  } = _ref3;
  return showHeader ? "linear-gradient(-135deg, ".concat(theme.uxfabric.components.dialog.dialogHeader.default.backgroundColor, " 50%, transparent 51%)") : "linear-gradient(-135deg, ".concat(theme.uxfabric.components.tooltip.default.backgroundColor, " 50%, transparent 51%)");
});
const StyledContainer = styled("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    box-shadow: ", ";\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.uxfabric.shape.global.popover.default.borderRadius;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.uxfabric.elevation.popover;
});
const HeaderBanner = styled("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    background: ", ";\n    border-style: solid;\n    border-width: 0.0625rem 0.0625rem 0 0.0625rem;\n    border-color: ", ";\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    height: 8px;\n"])), _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.uxfabric.components.dialog.dialogHeader.default.backgroundColor;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.uxfabric.components.dialog.dialogActions.default.borderColor;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.uxfabric.shape.global.popover.default.borderRadius;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.uxfabric.shape.global.popover.default.borderRadius;
});
let timerId = 0;
const UxTooltip = /*#__PURE__*/forwardRef(function UxTooltip(_ref0, ref) {
  let {
    open,
    children,
    handleClose,
    timeout = undefined,
    animationTimeout = 350,
    placement = "bottom",
    enableModArrow = false,
    modifiers = [],
    showHeader = false
  } = _ref0;
  const [arrowRef, setArrow] = useState(null);
  const setMouseOut = () => {
    if (timeout) {
      clearTimeout(timerId);
      timerId = setTimeout(handleClose, timeout);
    }
  };
  useEffect(() => {
    setMouseOut();
  });
  const setMouseIn = () => {
    if (timeout) clearTimeout(timerId);
  };
  if (!ref) return null;
  return /*#__PURE__*/React.createElement(FadeInAnimation, {
    show: open,
    timeout: animationTimeout
  }, /*#__PURE__*/React.createElement(Popper, {
    onMouseLeave: setMouseOut,
    onMouseEnter: setMouseIn,
    open: open,
    anchorEl: ref.current,
    keepMounted: true,
    disablePortal: true,
    modifiers: [...modifiers, {
      name: "arrow",
      enabled: enableModArrow,
      options: {
        element: arrowRef
      }
    }],
    placement: placement,
    "data-testid": "tooltip-popper",
    placeholder: undefined,
    onPointerEnterCapture: undefined,
    onPointerLeaveCapture: undefined
  }, /*#__PURE__*/React.createElement(Arrow, {
    ref: enableModArrow ? setArrow : null,
    showHeader: showHeader
  }), /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(StyledContainer, null, showHeader ? /*#__PURE__*/React.createElement(HeaderBanner, null) : null, children))));
});
export { UxTooltip as default };